// extracted by mini-css-extract-plugin
export default {"splitLine":"style_splitLine__98biV"};